import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { KakoCoin } from '../oil/OilIcons';
import { wbApi, fmt, dataHoraBr } from './wbApi';

const RES = { WIN_BIG: ['Balão dourado', 'text-amber-300'], WIN_SMALL: ['Prêmio', 'text-lime-300'], EMPTY: ['Vazio', 'text-purple-300/60'] };
const ENTREGA = { PENDING: 'entrega a caminho', PROCESSING: 'entrega a caminho', DELIVERED: 'entregue ✓', FAILED: 'entrega em análise', MANUAL_REVIEW: 'entrega em análise' };

/* Meus balões: histórico pessoal (vem do servidor) + resumo da carteira. */
export const WbMyPops = ({ me, tick }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    wbApi.get('/me/pops').then((r) => { if (alive) setData(r.data); }).catch(() => { if (alive) setData({ rows: [], wallet: {} }); });
    return () => { alive = false; };
  }, [tick]);
  if (!data) return <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-amber-400" /></div>;
  const w = data.wallet || {};
  return (
    <div className="space-y-3" data-testid="wb-my-pops">
      <div className="grid grid-cols-3 gap-2">
        {[['Estourados', me?.pops_total || 0, 'wb-me-pops'], ['Ganho em moedas', me?.prizes_total || 0, 'wb-me-prizes'], ['Moedas da Bruxa', w.earned || 0, 'wb-me-earned']].map(([l, v, t]) => (
          <div key={t} className="rounded-2xl border border-purple-800/60 bg-black/50 p-2 text-center">
            <p className="text-[8px] font-black uppercase tracking-widest text-purple-300/70">{l}</p>
            <p className="text-lg font-black text-amber-200" data-testid={t}>{fmt(v)}</p>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border border-purple-800/60 bg-black/50 p-3">
        <p className="mb-2 text-[10px] font-black uppercase tracking-[.2em] text-amber-400">Meus balões</p>
        {data.rows.length === 0 && <p className="py-4 text-center text-xs text-purple-200/60" data-testid="wb-my-pops-empty">Você ainda não estourou nenhum balão.</p>}
        <ul className="max-h-[360px] space-y-1.5 overflow-y-auto pr-1 wb-feed-scroll">
          {data.rows.map((r) => (
            <li key={r.pop_id} className="flex items-center justify-between rounded-xl bg-white/5 px-3 py-2 text-xs" data-testid="wb-my-pop-row">
              <div>
                <p className={`font-black ${RES[r.result]?.[1] || ''}`}>{RES[r.result]?.[0] || r.result}</p>
                <p className="text-[9px] text-purple-300/60" data-testid="wb-my-pop-meta">{dataHoraBr(r.created_at)}{r.fulfillment ? ` · ${ENTREGA[r.fulfillment] || 'entrega a caminho'}` : ''}</p>
              </div>
              {Number(r.prize) > 0 ? <span className="flex items-center gap-1 font-black text-amber-200"><KakoCoin className="h-4" /> +{fmt(r.prize)}</span>
                : <span className="text-purple-300/50">−{fmt(r.cost)} 🧙</span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
